<template>
	<div style="width:90%">
		<!-- 查询 -->
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="客户" label-width="80px">
						<el-input style="width: 200px;" v-model="searchInfo.customerName" placeholder="请输入客户"></el-input>
					</el-form-item>
				
					
					<el-form-item label="订单号" label-width="80px">
						<el-input style="width: 200px;" v-model="searchInfo.orderCode" placeholder="请输入订单号" >
						</el-input>
					</el-form-item>
					<el-form-item label="订单状态" label-width="80px">
						<el-select v-model="searchInfo.status" placeholder="请选择" style="width: 200px;">
						
							<el-option key="0" label="制单中" :value="0">制单中</el-option>
							<el-option key="1" label="在途" :value="1">在途</el-option>
							<el-option key="5" label="完成" :value="5">完成</el-option>
							
						</el-select>
					</el-form-item>
					<el-form-item label="承运日期" label-width="80px">
						<div class="block">
							<el-date-picker v-model="timerArr" value-format="yyyy-MM-dd" style="width: 200px;"
								type="daterange" start-placeholder="开始日期" end-placeholder="结束日期"
								>
							</el-date-picker>
						</div>
					</el-form-item>
					<el-form-item label="司机:" label-width="80px" >
						<el-select filterable v-model="searchInfo.driverId"  placeholder="请选择" clear style="width: 200px;">
							<el-option v-for="it in driverList" :key="it.id" :value="it.id"
							@click.native="changesj(it)"
								:label="it.driverName"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="车辆:" label-width="80px">
						<el-select style="width: 200px;" filterable v-model="carNumberplate"
						  placeholder="请选择" clear>
							<el-option v-for="it in arsList" 
							:key="it.id" 
						
							:value="it.carNumberplate"
							:label="it.carNumberplate"
							
							></el-option>
						</el-select>
					</el-form-item>
				
				
					
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
							<el-button type="primary" @click="downloadFile">
								导出
								<a href=""></a>
							</el-button>
							<el-button type="primary" @click="add">新增</el-button>
							<el-button :type="ids?'primary':''" @click="wc">一键完成</el-button>
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>
		<!-- 列表展示 -->
		<el-table :data="orderList" stripe style="width: 100%" v-loading="loading" element-loading-text="拼命加载中"
			element-loading-spinner="el-icon-loading"
			@selection-change="handleSelectionChange" border
			>
			<el-table-column
			    type="selection"
				align="center"
				:selectable="checkSelectable"
			    width="40">
			</el-table-column>
			<el-table-column type="expand" width="40">
				<template slot-scope="props">
					<el-form label-position="left" inline class="demo-table-expand">
						<div style="display: flex;">
							<el-form-item label="ID">
								<span>{{ props.row.id }}</span>
							</el-form-item>
							
							<el-form-item label="司机提成">
								<span>{{props.row.driveSendReward}}</span>
							</el-form-item>
							
							<el-form-item label="运费">
								<span>{{props.row.freightPrice}}</span>
							</el-form-item>
						</div>
						<div style="display: flex;">
							<el-form-item label="木板带板数量">
								<span>{{props.row.floorslabNum}}</span>
							</el-form-item>

							<el-form-item label="数量">
								<span>{{props.row.totalNum}} 台</span>
							</el-form-item>
							<el-form-item label="体积">
								<span>{{props.row.volume}} 方</span>
							</el-form-item>
						</div>
							
						
						<div style="display: flex;">
							<el-form-item label="重量">
								<span>{{props.row.weight}} 吨</span>
							</el-form-item>
							<el-form-item label="木板返回数量">
								<span>{{props.row.floorslabRebackNum}}</span>
							</el-form-item>
							<el-form-item label="承运日期">
								<span>{{props.row.sendDate}}</span>
							</el-form-item>
							
						</div>
						
						<div style="display: flex;">
							<el-form-item label="备注">
									<span>{{props.row.remark}}</span>
								</el-form-item>
							<el-form-item label="运输商品">
								<span @click="lookgoods(props.row.orderLists)">查看明细</span>
							</el-form-item>
						</div>
					</el-form>
				</template>
			</el-table-column>
			
			<el-table-column prop="customerName" label="客户" align="center" width="150" >
			</el-table-column>
			<el-table-column prop="orderCode" label="订单号" align="center" width=" 100" >
			</el-table-column>
			
			<el-table-column prop="typeName" label="订单类别" align="center" width="78" >
			</el-table-column>
			<el-table-column prop="carNumberplate" label="车牌号码" align="center" width="120" >
			</el-table-column>
			
			<el-table-column prop="driverName" label="司机名称" align="center" width="80" >
			</el-table-column>
			<el-table-column prop="routeName" label="线路名称" align="center" width="120" >
			</el-table-column>
		
			
			<el-table-column prop="billingType" label="计费方式" align="center" width="95" >
				<template slot-scope="scope">
					<span v-if="scope.row.billingType==1">按趟次单价</span>
					<span v-if="scope.row.billingType==2">按方数单价</span>
					<span v-if="scope.row.billingType==3">按吨数单价</span>
				
				</template>
			</el-table-column>
			<el-table-column prop="freightPrice" label="运费(￥)" align="center" width="75" >
			</el-table-column>
			<el-table-column prop="sendDate" label="承运日期" align="center" width="100" >
			</el-table-column>
			
			<el-table-column prop="status" label="状态" align="center" width="80" >
				<template slot-scope="scope">								
					<span v-if="scope.row.status==0">制单中</span>
					<span v-if="scope.row.status==1">在途</span>
					<span v-if="scope.row.status==5">完成</span>
				</template>
			</el-table-column>
			
			<el-table-column prop="operUser" label="制单操作人" align="center" width="95" >
			</el-table-column>
			<el-table-column prop="operationBy" label="到达操作人" align="center" width="95" >
			</el-table-column>
			<el-table-column prop="completeTime" label="到达时间" align="center" width="160" >
			</el-table-column>
			<el-table-column prop="createTime" label="创建时间" align="center" width="160" >
			</el-table-column>
			
			<el-table-column fixed="right" label="操作" align="center" width="180" >
				<template slot-scope="scope">
					
					<el-button size="small" type="text" @click="upd(scope.row.id)" v-if="scope.row.status!=5">编辑</el-button>
					<el-button size="small" type="text" @click="upd(scope.row.id)" v-if="scope.row.status==5">查看</el-button>

					<el-button size="small" type="text" @click="lookgoods(scope.row.orderLists)">查看明细
					</el-button>
					<el-button  size="small" type="text" @click="toDelete(scope.row)">删除
					</el-button>
					
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-pagination style="margin: 20px auto;width:100%;" background :current-page="sliderlist.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="sliderlist.total"
			@size-change="handleSizeChange">
		</el-pagination>
		<!-- 订单详情对话框 -->
	
		<el-dialog title="商品" :visible.sync="dialogVisible" width="60%" :before-close="handleClose"
			:close-on-click-modal="false">
			<el-table :data="dataList" size="mini" style="width: 100%;"
			current-row-key="index"
			>
				<el-table-column type="index" label="序号" width="50"></el-table-column>
				<el-table-column prop="pdtCode" label="商品编号" min-width="100">
				</el-table-column>
				<el-table-column prop="customerOrderCode" label="客户单号" min-width="100">
				</el-table-column>
				
				<el-table-column prop="goodsName" width="200" label="商品名称" align="center"
					class-name="small-padding ">
				</el-table-column>
				<el-table-column prop="num" label="数量" :show-overflow-tooltip="true" min-width="80">
					
				</el-table-column>
				<el-table-column prop="unitName" label="单位" :show-overflow-tooltip="true" min-width="100">
					
				</el-table-column>
				<el-table-column prop="remark" width="200" label="备注" fixed="right" align="center"
					class-name="small-padding fixed-width">
				
			
				</el-table-column>
				
			</el-table>
		</el-dialog>
		
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading: false,
				orderList: [],
				dialogVisible: false,
				dataList:[],
				searchInfo: {},
				orderCode:'',
				orderInfo: {},
				driverList:[],
				arsList:[],
				sliderlist: {},
				page: {
					pageNum: 1,
					pageSize: 10,
				},
				timerArr:[],
				provinceList: {},
				cityList: {},
				carNumberplate:'',
				districtList: {},
				deliverDialog: false, //发货弹窗
				sendRemark: '', // 发货备注
				sendOpUser: '', // 发货人
				expressCode: '', // 快递订单号
				expressId: '', // 快递公司id
				expressList: [], //快递公司列表
				showOrderInfo: [], //发货订单信息
				accountList: [],
				fhtype:'',
				name:'',
				unitList: [],
				ids:'',
				address:'',
				storeId:'', //登录者id
				type:'', // 登录者身份
			};
		},
		watch: {
			carNumberplate(newValue, oldValue) {
				// console.log(this.arsList);
				this.isJoinCar=this.arsList.find(item=>item.carNumberplate==newValue).isJoinCar
			},
		},
		methods: {
			wc(){
				if(this.ids){
					this.$api.wcorder({ids:this.ids}).then(res=>{
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.storeOrderList()
						} else {
							this.$message.error(res.message);
						}
					})
				}else{
					this.$message.error('请选择订单')
				}
				
			},
			checkSelectable(row) {
			  return row.status==1
			},
			handleSelectionChange(e){
				const wclist=[]
				// console.log(e);
				e.map(item=>{
					wclist.push(item.id)
				})
				this.ids=wclist.join(',')
				// console.log(this.ids);
			},
			changesj(e){
				// console.log(e);
				this.carNumberplate=e.carNumberplate
			},
			next(item,i,id) {
				if (this.$route.path != item.routePath) {
					if(i==1){
						this.$router.push(item.routePath)
					}else{
						this.$router.push({
							path:item.routePath,
							query:{
												     
									     id:id,
								}
							})
						
					}
				
				}
				if(JSON.stringify(this.$store.state.openTab).includes(item.routePath)){
					this.$store.commit('setactiveindex',item.routePath)
				}else{
					this.$store.commit('addtabs',item)
					this.$store.commit('setactiveindex',item.routePath)
						
				}
			},
			add(){
				
				let url='/orderManagement/newadd'
				this.$api.findByManageUserIdManageFunction().then((res) => {
					if (res.state == 'success') {
						
						res.data.forEach(item => {
						    item.manageFunctionList.forEach(i => {
						        if (i.routePath === url) {
						          this.next(i,'1')
						        }
						    });
						});
					}
				})
				
				// this.$store.commit('setactiveindex', '/orderManagement/add')
				// console.log(this.$store.state.activeIndex);
				//    this.$router.push({
				//    	path: this.$store.state.activeIndex,
					
				//    })
			
			},
			upd(id){
				let url='/orderManagement/newadd'
				this.$api.findByManageUserIdManageFunction().then((res) => {
					if (res.state == 'success') {
						// console.log(res.data);
						res.data.forEach(item => {
						    item.manageFunctionList.forEach(i => {
						        if (i.routePath === url) {
									// console.log(i);
						          this.next(i,'2',id)
						        }
						    });
						});
					}
				})
				  
			
			},
			/**
			 * 文件导出
			 */
			downloadFile() {
				let data = {
					...this.searchInfo,
					startTime: this.timerArr ? this.timerArr[0] : "",
					endTime: this.timerArr ? this.timerArr[1] : "",
					carNumberplate:this.carNumberplate,
					
					
				}
				this.$api.dcorder(data).then((res) => {
					// console.log(res.data)
					this.showloadFile(res.data)
				})
			},
			lookgoods(item){
				this.dataList=item
				this.dialogVisible=true
			},
			showloadFile(res) {
				if (!res) {
					return
				}
				const link = document.createElement('a');
				let blob = new Blob([res], {
					type: 'application/vnd.ms-excel'
				});
				link.style.display = 'none';
				link.href = URL.createObjectURL(blob);
				link.setAttribute('download', '运输订单' + '.xls');
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			},
		
			//展示发货弹窗
			showDeliver(item) {
				// console.log(item);
				this.fhtype=0
				
				this.showOrderInfo = []
				this.expressCode = ""
				this.sendRemark = ""
				this.sendOpUser = ""
				this.expressId = ""
				this.findExpress();
				this.showOrderInfo = item
				this.deliverDialog = true
				this.orderCode=item.orderCode
				this.name=item.name+"-"+item.phone
				this.address=item.address
			},
			// 查询
			search() {
				this.page.pageNum = 1;
				this.storeOrderList()
			},
			// 清空
			empty() {
				this.searchInfo = {}
				this.carNumberplate=''
				this.timerArr=[]
			},
			toDelete(e) {
				// console.log(e)
				var str = "此操作将删除该订单, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// console.log(e)
					this.$api.delorder(e.id).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.storeOrderList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			
			},
			storeOrderList() {
				this.loading = true
				let data = {
					pageNum: this.page.pageNum,
					startTime: this.timerArr ? this.timerArr[0] : "",
					endTime: this.timerArr ? this.timerArr[1] : "",
					pageSize: this.page.pageSize,
					carNumberplate:this.carNumberplate,
				...this.searchInfo
				}
				// console.log(data);
				this.$api.findorder(this.$encrypt(data)).then((res => {
				res.data=JSON.parse(this.$decrypt(res.data)).data
					// console.log('表格查询---', res)
					if (res.state == 'success') {
						this.orderList = res.data.list.list
						// console.log('表格查询---', this.orderList);
						this.sliderlist = res.data.list
						this.loading = false
					}
				}))
				//查询省
				
			},
			//查询市
			

			districtFcus(e) {
				let obj = {};
				obj = this.districtList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.orderInfo.area = obj.name
			},
			// 订单详情查询
			showContent(e) {
				let data = {
					id: e.id,
					areaId: e.areaId,
					provinceId: e.provinceId,
					cityId: e.cityId
				}
				this.$api.findOrderInfo(this.$encrypt(data)).then((res) => {
					res=JSON.parse(this.$decrypt(res.data))
					if (res.state == 'success') {
						this.orderInfo = res.data
						this.dialogVisible = true
					} else {
						this.$message.error(res.message)
					}
				})
			},
			handleClose() {
				this.dialogVisible = false
			},
			pageChange(data) {
				this.page.pageNum = data
				this.storeOrderList();
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.storeOrderList()
			},
			
		},

		created() {
			this.$api.fdriverList(this.$encrypt({})).then(res => {
				res.data=JSON.parse(this.$decrypt(res.data)).data
				this.driverList = res.data
			})
			this.$api.fcarsList(this.$encrypt({})).then(res => {
				res.data=JSON.parse(this.$decrypt(res.data)).data
				this.arsList = res.data
			})
			this.$api.findPmsUnit({}).then(res => {
				// console.log(res.data.list);
				this.unitList = res.data.list
			})
			this.storeOrderList();
		
		},
	};
</script>

<style>
	.orderxq {
		display: flex;
		width: 50%;
		align-items: flex-start;

	}

	.orderList {
		display: flex;
		align-items: center;
		flex-wrap: wrap;

	}
</style>
